import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import styled from 'styled-components';
import { rem } from 'polished';
import objectPath from 'object-path';
import { bp, megaText } from 'Styles/helpers';
import screen from 'superior-mq';
import handleData from 'Lib/handleData';
import Input from '../../forms/input';
import Button from '../../button';
import RenderMd from '../../render-md';

export default class ListForm extends PureComponent {

  static propTypes = {
    formTitle: PropTypes.string,
    form: PropTypes.object,
    formSuccess: PropTypes.object,
  }

  constructor(props) {
    super(props);

    this.form = React.createRef();
    this.state = {
      formStatus: undefined,
      formHeight: undefined,
    };
  }

  setInitialValues = () => {
    const values = {};

    for (let i = 0; i < this.props.form.questions.length; i++) {
      const key = `q${i}`;

      values[key] = '';
    }

    return values;
  }

  onSubmit = (values, { setSubmitting }) => {
    const questions = this.props.form.questions.map((q, i) => ({
      text: q.question,
      answer: values[`q${i}`],
    }));

    const formHeight = this.form.current && this.form.current.offsetHeight;

    handleData('POST', `/v1/lists/${this.props.listId}`, { questions })
      .then(() => {
        this.setState({
          formStatus: 'success',
          formHeight,
        });
      })
      .catch(() => {
        this.setState({
          formStatus: 'There was an error submitting your response. Please try again.',
        });
      });

    setSubmitting(false);
  }

  render() {
    if (!this.props.form) return null;

    const { formSuccess, formTitle, form } = this.props;

    return (
      <FormWrap>
        {this.state.formStatus === 'success'
          ?
            <ThankYou style={{ height: this.state.formHeight }}>
              <ThankYouWrap>
                <ThankYouTitle>{objectPath.get(formSuccess, 'fields.title', 'Thank You')}</ThankYouTitle>

                {objectPath.has(formSuccess, 'fields.content ') &&
                  <ThankYouContent>
                    <RenderMd source={formSuccess.fields.content} />
                  </ThankYouContent>
                }

              </ThankYouWrap>
            </ThankYou>
          :
            <Formik
              initialValues={this.setInitialValues()}
              onSubmit={this.onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                dirty,
              }) => (
                <StyledForm onSubmit={handleSubmit} ref={this.form}>
                  <h3>{formTitle}</h3>

                  {form.questions.map((q, i) => (
                    <Fragment key={q.id}>
                      <label htmlFor={`q${i}`}>{q.question}</label>
                      <ListFormInput>
                        <Input
                          type="text"
                          name={`q${i}`}
                          id={`q${i}`}
                          placeholder="Your Answer"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          errors={errors.email && touched.email && errors.email}
                          isDark
                        />
                      </ListFormInput>
                    </Fragment>
                  ))}

                  <ButtonWrap>
                    <Button
                      isdark
                      disabled={isSubmitting || !dirty}
                      type="submit"
                    >
                      Submit
                    </Button>

                    {this.state.formStatus && this.state.formStatus !== 'success' &&
                      <FormError>
                        {this.state.formStatus}
                      </FormError>
                    }
                  </ButtonWrap>

                </StyledForm>
              )}
            </Formik>
        }

      </FormWrap>
    );
  }
}

const FormWrap = styled.div`
  margin-top: 140px;
`;

const ButtonWrap = styled.div`
  position: relative;
`;

const StyledForm = styled.form`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 20px;

  label {
    color: ${props => props.theme.blue};
    font-size: ${rem(16)};
    grid-column: 1 / span 4;

    ${screen.above(bp.mobile, `
      padding-top: 5px;
      text-align: right;
    `)}

    ${screen.below(bp.mobile, `
      grid-column: 1 / -1;
    `)};
  }

  input {
    color: #fff;
  }

  h3,
  ${ButtonWrap} {
    grid-column: 6 / -1;

    ${screen.below(bp.mobile, `
      grid-column: 1 / -1;
    `)};
  }

  ${ButtonWrap} {
    ${screen.below(bp.mobile, `
      place-self: center;
    `)};
  }

  ${screen.below(bp.laptop, `
    margin-top: 105px;
  `)};

  ${screen.below(bp.mobile, `
    margin-top: 65px;
    grid-gap: 0;

    h3 {
      text-align: center;

      ${screen.below(bp.mobile, `
        margin-bottom: 32px;
      `)};
    }
  `)};
`;

const ThankYou = styled.div`
  display: flex;
`;

const ThankYouWrap = styled.div`
  margin: auto;
  text-align: center;
`;

const ThankYouTitle = styled.h3`
  ${megaText()};
  color: ${props => props.theme.blue};
`;

const ThankYouContent = styled.div`
  max-width: 990px;
  margin: auto;
`;

const ListFormInput = styled.div`
  grid-column: 6 / -1;

  ${screen.below(bp.mobile, `
    grid-column: 1 / -1;
  `)};
`;

const FormError = styled.p`
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  margin: 0;
  color: ${props => props.theme.error};
  font-size: ${rem(14)};
  line-height: 1;
  font-weight: 600;

  ${screen.below(bp.mobile, `
    text-align: center;
  `)};
`;
